import { Dimensions } from "react-native";
const { width, height } = Dimensions.get("window");
import { RFPercentage, RFValue } from "../utilities/customFont";


export const DIMENSIONS = {
  width: width,
  height: height
}

export const COLORS = {
  black: "#02122C",
  black200:"#25243b",
  black300:'#1c1939',
  black400:'#262626',
  black450:"#100f29",
  white: "#FFFFFF",
  white200: "#f6f6f6",
  gray: "#6A6A6A",
  blue: "#0682FE",
  blue200:'#055eef',
  blue300:'#1154d0',
  blue400:'#0080fa',
  blue500:'#2170ff',
  blue550:'#f0f9ff',
  primary: "#9c1d26",
  boderColor: "#CCD0D5",
  green: '#38842A',
  green100:'#b3f4ce',
  green200:'#4aa15f',
  error: '#D0021B',
  yellow: '#FFCB05',
  yellow200:'#ffdf66',
  yellow300:'#f8b43c',
  red: '#BD2D37',
  red200:'#ce1230',
  lightGray: '#D8D8D8',
  gray300: '#c3c3c3',
  gray200:'#a0a0a0',
  gray250:'#a9acb4',
  gray350:'#ccd0d5',
  gray700:"#54565b",
  lightGrayOp20: '#f7f7f7',
  darkGray : "#66625f",
  raised: '#FF4242',
  inProgress: '#FF9007',
  success: '#43B32E',
  lightGreen: '#4BA13B',
  whiteThree : '#f6f6f6',
  cardNumber4: "rgba(117,55,150,0.06)",
  cardNumber5: "rgba(238, 120, 48, 0.06)",
  cardNumber6: "rgba(230, 210, 0, 0.06)",
  cardNumber7: "rgba(51, 144, 64, 0.06)",
  cardNumber12: "rgba(226, 17, 134, 0.06)",
  cardNumber15: "rgba(34, 138, 205, 0.06)",
  cardNumber16: "rgba(63, 83, 90, 0.06)",
  darkBlueGrey : "#19273f",
  charcoal : "#212820",
  mediumGrey : "#797a74",
  dark : "#252939",
  warmGrey : "#999999",
  darkBlack : "#000000",
  shamrock : "#00b955",
  white1 : "#dfdfdf",
  charcoalTwo : "#1f281f",
  whiteTwo : "#fdfcfc",
  brownishGrey : '#5f5f5f',
  warmGrey1 : '#757575',
  warmGrey2:'#707070',
  grayOP69 : "#f3f3f3",
  divider : '#c7c7c7',
  navyBlue:'#1d337e',
  orange:'#f85a59',
  yellow:'#f5c240',
  lightRed:'#ffd1cd',
  cardBg:"#bc2d37",
  cardHeaderBg:"#ad2933",
  lightYellow:'#f6b931',
  lightOrange:'#db6735',
  maroon:'#9c1d25',
  orange200:'#d1451a',
  orange250:'#ffeec6',
  orange300:'#bf8703',
  orange350:'#ff9006',
  gold:"#c68f03",
  purple:"#917aef",
  red650: "#d87585",
  red700: "#9c1d25",
  red750: "#a72339",
  red800: "#ad2933",
  red600:'#ffeeee',
  red900:'#fe8082',
  red300:'#bd2d37'


};
export const SIZES = {
  // global sizes
  base: 8,
  font: 14,
  radius: 12,
  padding: 24,

  // font sizes
  h1: 30,
  h2: 22,
  h3: 16,
  h4: 14,
  body1: 30,
  body2: 22,
  body3: 16,
  body4: 14,
  body5: 12,

  // app dimensions
  width,
  height
};
export const FONTS = {
  h1: { fontFamily: "Inter", fontSize: SIZES.h1, lineHeight: 36, fontWeight: "700" },
  h2: { fontFamily: "Inter", fontSize: SIZES.h2, lineHeight: 30, fontWeight: "700" },
  h3: { fontFamily: "Inter", fontSize: SIZES.h3, lineHeight: 22, fontWeight: "700" },
  h4: { fontFamily: "Inter", fontSize: SIZES.h4, lineHeight: 22, fontWeight: "700" },
  body1: { fontFamily: "Inter", fontSize: SIZES.body1, lineHeight: 36 },
  body2: { fontFamily: "Inter", fontSize: SIZES.body2, lineHeight: 30 },
  body3: { fontFamily: "Inter", fontSize: SIZES.body3, lineHeight: 22 },
  body4: { fontFamily: "Inter", fontSize: SIZES.body4, lineHeight: 22 },
  body5: { fontFamily: "Inter", fontSize: SIZES.body5, lineHeight: 18, fontWeight: "400" },
  medium: { fontFamily: "Inter", fontSize: SIZES.body4, lineHeight: 18 },
  fontMedium: { fontFamily: "Inter" },
  fontSemi: { fontFamily: "Inter" },
  fontRegular: { fontFamily: "Inter" },
  fontBold: { fontFamily: "Inter" },
  fontPoppins: {fontFamily:"Inter"},
  Inter : "Inter",
  InterBold :"Inter",
  InterSemiBold : "Inter",
  InterThin :"Inter",
  InterMedium :"Inter"

};
export const FONTSIZE = {
  SIZE2:RFValue(0),
  SIZE3:RFValue(1),
  SIZE4:RFValue(2),
  SIZE5:RFValue(3),
  SIZE6:RFValue(4),
  SIZE7:RFValue(5),
  SIZE8:RFValue(6),
  SIZE9:RFValue(7),
  SIZE10:RFValue(8),
  SIZE11:RFValue(9),
  SIZE12:RFValue(10),
  SIZE13:RFValue(11),
  SIZE14:RFValue(12),
  SIZE15:RFValue(13),
  SIZE16:RFValue(14),
  SIZE17:RFValue(15),
  SIZE18:RFValue(16),
  SIZE19:RFValue(17),
  SIZE20:RFValue(18),
  SIZE21:RFValue(19),
  SIZE22:RFValue(20),
  SIZE23:RFValue(21),
  SIZE24:RFValue(22),
  SIZE25:RFValue(23),
  SIZE26:RFValue(24),
  SIZE27:RFValue(25),
  SIZE28:RFValue(26),
  SIZE29:RFValue(27),
  SIZE30:RFValue(28),
};

export const TITLE = {
  changeVehicle: "Change Vehicle",
  assignedVehicles: "Assigned Vehicles",
  assignVehicles: "Assign Vehicles",
  changeDriver: "Change Driver",
  activateDriver: "Activate Driver",
  assignedDrivers: "Assigned Drivers",
  driverList: "Driver List",
  vehicleList: "Vehicle List",
  activateVehicle: "Activate Vehicle",
};

export const TIMER = 60; //sec

const appTheme = { COLORS, SIZES, FONTS, DIMENSIONS, TITLE, TIMER,FONTSIZE };

export default appTheme;
